export default __webpack_public_path__ + "static/media/Times New Roman Italic.99dbcd86.ttf";